import {gql, useMutation} from "@apollo/client";

const ADD_STAGE_MUTATION = gql`
mutation CreateStage($name: String!, $scheduleType: String!, $qtyTeamsQualified: Int, $qtyTeamsAdditional: Int, $seasonId: Int, $gamesMode: String, $minGamesRequired: Int) {
  createStage(name: $name, scheduleType: $scheduleType, qtyTeamsQualified: $qtyTeamsQualified, qtyTeamsAdditional: $qtyTeamsAdditional, seasonId: $seasonId, gamesMode: $gamesMode, minGamesRequired: $minGamesRequired) {
    stage{
        id
        name
        scheduleType
        gamesMode
    }
    
  }
}
`;

export default function AddStageMutation() {
    return useMutation(ADD_STAGE_MUTATION);
}